import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c24ce1a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-box tw-flex tw-justify-center search-mobile tw-items-center" }
const _hoisted_2 = ["value", "placeholder"]

import SearchIcon from "@/components/svgs/searchIcon.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'searchInput',
  props: {
  hintText: {
    type: String,
    required: true,
  },
  modelValue: {
    type: String,
    required: true,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props;


// eslint-disable-next-line no-unused-vars


const updateInput = (e: any) => {
  emit("update:modelValue", e.target.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SearchIcon, {
      size: 15,
      color: "#878787"
    }),
    _createElementVNode("input", {
      value: __props.modelValue,
      type: "text",
      placeholder: __props.hintText,
      class: "autoFocusNotify",
      onInput: updateInput
    }, null, 40, _hoisted_2)
  ]))
}
}

})